import styled from 'styled-components'
import type { ReactNode, Ref } from 'react'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import Divider from 'LuxKit/Divider'
import OfferPageSignUpContent from './OfferPageSignUpContent'

const GradientWrapper = styled(LayoutContainer)`
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: ${rem(-200)};
    inset-inline: 0;
    height: ${rem(200)};
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    pointer-events: none;
  }
`

interface Props {
  ref?: Ref<HTMLDivElement>
  offerType: App.OfferType
  saveUpToPercent?: number
  content?: ReactNode
}

function OfferPageSignUpWall(props: Props) {
  const { ref, offerType, saveUpToPercent, content } = props

  return (
    <GradientWrapper ref={ref}>
      <div id="ticket-options" />
      <div id="facilities-all" />
      <div id="soft-wall" />
      <Group direction="vertical" gap={40} tabletGap={80}>
        <Divider kind="primary" />
        {content ?? <OfferPageSignUpContent offerType={offerType} saveUpToPercent={saveUpToPercent} />}
      </Group>
    </GradientWrapper>
  )
}

export default OfferPageSignUpWall
